<template>
  <div class="register">
    <div class="centered">
      <div>
        <img v-if="style=='vm'" class="logo" src="../assets/vm/VM-logo1.svg" style="width:200px;"/>
        <img v-if="style=='ox'" class="logo" src="../assets/ox/OX-logo2.svg" style="width:140px;"/>
        <img v-if="style=='bvs'" class="logo" src="../assets/bvs/BVS-logo2.svg"
          style="width:200px;"/>
        <a v-if="style=='db'" style="width:200px; display:block; margin: 0px auto 40px;"
          href="https://www.doelbeleggen.nl"><img src="../assets/db/DB-logo3.svg" /></a>
        <div v-if="msg.msg" :class="['row form-' + msg.type]">
          {{ msg.msg }}
          <span v-if="msg.msg == 'E-mailadres al in gebruik.'"><br><br>Wachtwoord vergeten?<br>
            <a style="text-decoration:underline;font-weight:600;cursor:pointer"
              @click="requestPassword">Nogmaals wachtwoordlink e-mailen</a>
          </span>
        </div>
        <div class="card">
          <div class="row" style="padding:20px;">
            <template v-if="style=='db'">
              Maak uw doel concreet en bereken direct de haalbaarheid! U ontvangt een e-mail om
              later weer bij uw doel te kunnen.<br><br>
            </template>
            <template v-else>
              <h2>Leuk dat u bij ons wilt komen beleggen!</h2>
              <p>Voordat we verder gaan met het openen van uw rekening, hebben we uw e-mailadres
              nodig. U ontvangt dan een e-mail waarmee u later weer bij uw vragenlijst kunt
              komen.</p>
            </template>
            <form @submit.prevent>
              <input ref="email" name="email" type="email" placeholder="E-mailadres" autofocus
                @change="msg.msg=null" @keyup.enter="register">
              <button @click="register">Bepaal uw doel</button>
            </form>
          </div>
        </div>
        <div v-if="style=='db'" class="register-link">
          Al klant? <a @click="toLogin" style="cursor:pointer">Inloggen met bestaand account.</a>
        </div>
      </div>
    </div>
    <div class="privacy">
      <a v-if="style=='ox'" href="https://oxby.nl/documentencentrum/privacy-statement/"
        target="_blank">Online Privacy &amp; Beleid</a>
      <a v-if="style=='bvs'" href="https://beervanstapele.nl/online-privacy/"
        target="_blank">Online Privacy &amp; Beleid</a>
      <a v-if="style=='vm'" href="https://velthuysemulder.nl/online-privacy/"
        target="_blank">Online Privacy &amp; Beleid</a>
      <template v-if="style=='db'">
        <a href="https://www.doelbeleggen.nl">Doelbeleggen.nl</a><br>
        <a href="https://www.doelbeleggen.nl/documentencentrum/privacy-statement/">Online Privacy
        &amp; Beleid</a>
      </template>
      <p class="disclaimer">
        Door het versturen van uw gegevens verleent u {{brandname}} en met haar verbonden
        onder{{'\xad'}}nemingen in de financiële sector toestemming om u te informeren over onze
        producten en diensten. Zolang dat voor marketing{{'\xad'}}doeleinden van belang is,
        worden uw gegevens bewaard.
        Als u hiertegen bezwaar heeft, kunt u een e-mail sturen naar {{brandmail}}. Tevens
        kunt u zich altijd uitschrijven via de 'afmelden' link onderin de e-mail. U heeft het recht
        een verzoek in te dienen om inzage van en rectificatie of wissing van uw persoonsgegevens
        en u heeft het recht een klacht in te dienen bij een toezichthoudende autoriteit.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserRegister',
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
      msg: { msg: null, type: 'notice' },
      brandname: process.env.VUE_APP_STYLE === 'ox' ? 'OXBY' : 'Doelbeleggen',
      brandmail: process.env.VUE_APP_STYLE === 'ox' ? 'info@oxby.nl' : 'info@doelbeleggen.nl',
    };
  },
  mounted() {
    this.$refs.email.focus();
  },
  methods: {
    requestPassword() {
      this.sdk.resetPassword(
        this.$refs.email.value,
        () => {
          this.$refs.email.value = '';
          this.msg.msg = 'Wachtwoord herstelmail is nogmaals verstuurd.';
          this.msg.type = 'success';
        },
      );
    },
    register() {
      this.sdk.register(
        this.$refs.email.value,
        this.$refs.email.value,
        (response) => {
          if (response.status === 200) {
            window.location.href = `?intake=${response.data.intake}`;
          } else if (response.status === 429) {
            if (response.data.registerTimeout === 'timeout') {
              this.msg = { msg: 'Te veel pogingen tot registratie in de laatste minuut, probeer het over een paar minuten nog eens.', type: 'notice' };
            } else if (response.data.registerTimeout === 'ban') {
              this.msg = { msg: 'Te veel pogingen tot registratie in de laatste 12 uur, probeer het over 24 uur nog eens.', type: 'notice' };
            }
          } else {
            this.msg = { msg: response.data.message, type: 'error' };
          }
        },
        this.getQueryVariable('goal') || null,
        this.getQueryVariable('advisor') || null,
      );
    },
    toLogin() {
      window.location.href = '?';
    },
  },
};
</script>

<style lang="scss" scoped>
  .register {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: $color-background;
    background-position: center;
    height: 100vh;
    @media #{$desktop} {
      @if $brand == DB {
        &:before {
          content : "";
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background-image: url('../assets/db/registratie.png');
          background-position: center;
          opacity: 0;
          animation: fadeInFromNone 3s ease;
          animation-fill-mode: forwards;
          animation-delay: 1s;
        }
      }
    }
  }
  @keyframes fadeInFromNone {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  .centered {
    @media #{$desktop} {
      position: fixed;
      top: 40%;
      left: 50%;
      max-width: 300px;
      > * {
        transform: translate(-50%, -50%);
      }
    }
    @media #{$mobile} {
      padding: 20px;
    }
  }
  .register-link {
    color: #fff;
    text-align: center;
    display: block;
    margin: 40px auto 20px;
    a {
      color: $color-highlight;
    }
  }
  .logo {
    display: block;
    margin: 40px auto;
    @media #{$mobile} {
      margin-top:20px;
      @media (orientation: landscape) {
        display: none;
      }
    }
  }
  .bg-img {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
     @media #{$mobile} {
       display: none;
     }
  }
  .disclaimer {
    color: rgba(255,255,255,.5);
    text-align: justify;
    margin: 20px auto;
    max-width: 640px;
    padding: 0 20px;
  }
  .privacy {
    text-align: center;
    color: #fff;
    @media #{$desktop} {
      position: fixed;
      bottom: 40px;
      left: 0;
      right: 0;
    }
    @media #{$mobile} {
      @media (orientation: landscape) {
        display: none;
      }
    }
  }
  .form-error, .form-notice, .form-success {
    border-radius: 2px;
  }
  .card {
    border-radius: 2px;
    color: $color-background;
    overflow: hidden;
    background-color: $color-lightgrey2;
    margin-top: 20px;
    p, h2 {
      color: $color-background;
      margin: 20px 0px 20px 0px;
      width: 100%;
    }
    input, button {
      margin: 10px 0px 0 0px;
      width: 100%;
    }
  }
</style>
